import React from "react";

const EmployeeDropdownOption = (props) => {
  return <div className="options-title w90">{props.title}</div>;
};

export default EmployeeDropdownOption;
